// extracted by mini-css-extract-plugin
module.exports = {"container":"ApproveReject_container__FLmi0","btn":"ApproveReject_btn__1_z1J","btnIconWrapper":"ApproveReject_btnIconWrapper__1I2eV"};